import React from "react";
import env from "env";
import { useState, useEffect } from "react";
import { Table } from "components/table/table";
import { SiteLink } from "components";
import { getIdToken } from 'lib/auth/services/authHelper';

export function List(props) {
  const [result, setResult] = useState([]);
  const [triggerResult, setTriggerResult] = useState(0);
  const [resultUpdate, setResultUpdate] = useState(0);
  const [status, setStatus] = useState("");
  const [remove, setRemove] = useState();
  //const _autSession = props._autSession;

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "productName",
        Cell: (c) => {
          return (
            <SiteLink to={`/admin/atdw/edit/${c.row.original.productId}`}>
              <b>{c.cell.value}</b>
            </SiteLink>
          );
        },
      },
      {
        Header: "Town",
        accessor: "town",
      },
      {
        Header: "Address",
        accessor: "address",
      },
      {
        Header: "Area",
        accessor: (c) => {
          return c.displayArea && c.displayArea !== "" ? c.displayArea : c.area;
        },
      },
      {
        Header: "Remove",
        accessor: "",
        Cell: (c) => {
          return (
            <button
              disabled={status === "Syncing....."}
              className="btn btn btn-primary"
              onClick={() => {
                setRemove(c.row.original.productId);
              }}
            >
              Remove
            </button>
          );
        },
      },
    ],
    [status]
  );

  useEffect(() => {
    if (!remove) {
      return;
    }
    const fetchData = async () => {
      const res = await fetch(
        env.apiBase + "/api/atdwadmin/removeatdw/" + remove
      );
      const data = await res.json();
      if (data === "ok") {
        //window.location.reload(false);
        // setTriggerResult(pre => {
        //     let _new = {...pre};
        //     _new = _new + 1;
        //     return _new;
        // });
        setTriggerResult(1);
      }
    };
    fetchData();
  }, [remove]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(env.apiBase + "/api/atdwadmin/getatdwlist");
      const data = await res.json();
      if (!data.error) {
        setResult(data);
      }
    };
    fetchData();
    setTriggerResult(0);
  }, [triggerResult]);

  useEffect(() => {
    if (resultUpdate === 0) {
      return;
    }
    setStatus("Syncing.....");
    const fetchData = async () => {
      const _token = await getIdToken();
      const res = await fetch(env.apiBase + "/api/atdwadmin/updateatdw", {
        method: "get",
        headers: { Authorization: `Bearer ${_token}` },
      });
      const data = await res.json();
      console.log("data", data);

      setStatus("");
      if (data.error) {
        setStatus("Error");
      }
      setTriggerResult(1);
    };
    fetchData();
  }, [resultUpdate]);

  return (
    <>
      <div>
        <button
          disabled={status === "Syncing....."}
          className="btn btn btn-primary"
          onClick={() => {
            setResultUpdate(resultUpdate + 1);
          }}
        >
          Update ATDW
        </button>
        <span style={{ marginLeft: "1rem" }}> {status} </span>
      </div>
      <Table columns={columns} data={result} />
    </>
  );
}
